const GENERIC_QUESTIONS = [
  'qid_business_trade',
  'qid_postcode',
  'qid_service_selection',
  'qid_current_supplier'
]

const NotasPayloadBuilder = {
  respondent (address, lead) {
    return {
      address: this.address(address),
      businessName: lead.businessName,
      name: lead.name,
      email: lead.email,
      telephoneNumber: lead.telephoneNumber,
      contactDateTime: lead.contactDateTime
    }
  },

  address (address) {
    return { ...address, loqateId: address.id, id: undefined }
  },

  question (question, service) {
    return {
      questionId: question.questionId,
      title: question.title[service] || question.title,
      description: question.subtitle,
      visibility: question.visibility,
      type: question.type
    }
  },

  supplier (result) {
    return {
      broadband: { value: result.broadband.value, name: result.broadband.name },
      phone: { value: result.phone.value, name: result.phone.name }
    }
  },

  answerResult (result, question) {
    switch (question.questionId) {
      case 'qid_current_supplier':
        return this.supplier(result)
      default:
        return result
    }
  },

  answers (answers, questions, service) {
    return Object.entries(answers).reduce((accumulator, [questionId, answer]) => {
      const question = questions.find(question => question.questionId === questionId)

      if (!question) return accumulator

      let index
      if (GENERIC_QUESTIONS.includes(questionId)) {
        index = 'generic'
      } else {
        index = this.visibilityToString(question.visibility)
      }
      accumulator[index].push({
        question: this.question(question, service),
        result: this.answerResult(answer.result, question)
      })

      return accumulator
    }, { phone: [], broadband: [], generic: [] })
  },

  visibilityToString (visibility) {
    if (visibility.broadband) return 'broadband'
    if (visibility.phone) return 'phone'

    throw new Error('Invalid question visibility')
  },

  phoneRecommendation (score) {
    switch (score) {
      case 'low':
        return 'basic landline'
      case 'medium':
        return 'standard landline'
      case 'high':
        return 'advanced landline'
      default:
        throw new Error('Invalid phone score')
    }
  },

  broadbandRecommendation (score) {
    if (score >= 100) return 'fast fibre'
    if (score >= 12) return 'standard fibre'
    if (score >= 0) return 'ADSL'

    throw new Error('Invalid broadband score')
  },

  results ({ phone, broadband }) {
    return {
      phone: {
        score: phone,
        recommendation: this.phoneRecommendation(phone)
      },
      broadband: {
        score: broadband,
        recommendation: this.broadbandRecommendation(broadband)
      }
    }
  },

  build ({ address, lead, answers, questions, service, scores }) {
    const { phone, broadband, generic } = this.answers(answers, questions, service)

    const { phone: phoneResult, broadband: broadbandResult } = this.results(scores)

    const payload = {
      requestOptions: { isTelco: true },
      respondent: this.respondent(address, lead),
      telco: { answers: generic }
    }

    if (phone.length > 0) {
      payload.telco.phone = { answers: phone, result: phoneResult }
    }

    if (broadband.length > 0) {
      payload.telco.broadband = { answers: broadband, result: broadbandResult }
    }

    return payload
  }
}

export default NotasPayloadBuilder
